module.exports = [{"value":"IFWO_&_SIC","text":"IFWO_&_SIC"},{"value":"SIC Only for 6BR","text":"SIC Only for 6BR"},{"value":"SPA ","text":"SPA "},{}]


//////////////////
// WEBPACK FOOTER
// ./static/moduleName.json
// module id = ./static/moduleName.json
// module chunks = 0 1 2 3 4 6 10 13